/**
 * Nested menu.
 *
 * This code is common for horizontal and vertical nested menus.
 */
const menu_nested = (args) => {
    // setup args
    let menu = args.menu;

    const caret_opened_event = new Event('caretopened');

    // validate
    if (!menu) {
        // console.log('Invalid args');
        return;
    }

    // require tools
    if (typeof window.nested_menu_tools === 'undefined') {
        // console.log('Nested menu tools undefined');
        return;
    }

    /**
     * Event: Menu caret clicked
     *
     * Open sub-menu and change caret state
     */
    function caretClickEvent(e) {
        // console.log('Menu caret clicked');

        const li = window.nested_menu_tools.getAncestor(
            menu,
            e.currentTarget,
            'menu-item-has-children'
        );

        const result = window.nested_menu_tools.toggleMenuItem(menu, li);

        if (result > 0) {
            li.dispatchEvent(caret_opened_event);
        }

        // don't trigger parent(s)
        e.stopPropagation();
    }

    /**
     * Event: Click on empty link (a[href="#"])
     */
    function emptyLinkClickEvent(e) {
        // cancel default action
        e.preventDefault();

        // activate or deactivate <li>
        const li = window.nested_menu_tools.getAncestor(
            menu,
            e.currentTarget,
            'menu-item-has-children'
        );
        if (li) {
            if (li.classList.contains('-is-clicked')) {
                window.nested_menu_tools.deactivateMenuItem(li);
                li.classList.remove('-is-clicked');
            } else {
                window.nested_menu_tools.activateMenuItem(menu, li);
                li.classList.add('-is-clicked');
            }
        }
    }

    function init() {
        // console.log('init nested menu');

        // close all menus
        window.nested_menu_tools.resetMenuItems(menu);

        // setup click hooks (carets)
        const menuCarets = menu.querySelectorAll('.js-menu-caret');
        for (let k = 0; k < menuCarets.length; k++) {
            menuCarets[k].addEventListener('click', caretClickEvent);
        }

        // setup click hooks (empty links)
        const emptyLinks = menu.querySelectorAll('a:not([href])');
        for (let l = 0; l < emptyLinks.length; l++) {
            emptyLinks[l].addEventListener('click', emptyLinkClickEvent);
            emptyLinks[l].setAttribute('aria-hidden', true);
        }
    }

    init();

    // make the call chainable
    return this;
};

document.querySelectorAll('.js-menu-nested').forEach((menu) => {
    menu_nested({
        menu: menu,
    });
});
